/*
 * @Description: 
 * @Autor: yd
 * @Date: 2020-09-15 09:25:39
 * @LastEditors: yd
 * @LastEditTime: 2020-09-15 15:13:16
 */
//历史邮件
import http from '../httpConfig'

const table = "mrbase_sys_mail_send"

// 历史邮件列表
export const historyMailList = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/mailhistory/list-mailHistory/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//历史邮件详情
export const historyMailDetails = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/mailhistory/find-mailHistory/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


//修改历史邮件  邮件发送历史记录错误邮件修改保存接口
export const historyEmailUpdate = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/mailhistory/update-mailHistory/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


//重新发送历史邮件
export const historyMailResend = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/mailhistory/send-error-mail/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
